export * from './src/keepalive';
export { NgIdleKeepaliveModule } from './src/module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ng-idle/keepalive/index.js
// module id = ./node_modules/@ng-idle/keepalive/index.js
// module chunks = vendor